// +----------------------------------------------------------------------
// | 模式切换：💭 正常 / ⚡ 30 秒决定 / 🎲 随便吧
// +----------------------------------------------------------------------
import { MODE_MAP } from '../../lib/categoryMap';
import './ModeSwitch.less';

const ORDER = ['normal', 'quick', 'random'];

export default function ModeSwitch({ value = 'normal', onChange, disabled = false }) {
  return (
    <div className="mode-switch">
      {ORDER.map((key) => {
        const item = MODE_MAP[key];
        const active = value === key;
        return (
          <button
            key={key}
            type="button"
            className={`mode-switch-item ${active ? 'is-active' : ''}`}
            onClick={() => !disabled && onChange(key)}
            disabled={disabled}
            title={item.desc}
          >
            <span className="mode-switch-emoji">{item.emoji}</span>
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}
